export const pixDiscountBlacklist = [
    'GENUINATOYOTA',
    'GENUINAKIAHYUNDAI',
    'GENUINAHONDA',
    'GENUINAHONDAMOTOS',
]